import { UrlAdaptor } from '@syncfusion/ej2-data';

// Constructor function for the custom adapter
function ScheduleCustomAdaptor() {
  // We call the UrlAdaptor constructor
  UrlAdaptor.call(this);

  // Override the `processQuery` method to add the parameters correctly
  this.processQuery = function(dm, query, hierarchyFilters) {
    // Call the original UrlAdaptor method to get the base request
    let request = UrlAdaptor.prototype.processQuery.call(this, dm, query, hierarchyFilters);
    
    // Get the query parameters (addParams)
    let queryParams = query.params;
    
    // Convert parameters to string format to add to the URL
    let paramString = '';
    if (Array.isArray(queryParams)) {  // Making sure queryParams is an array
      for (let param of queryParams) {
        if (param.key !== undefined && param.value !== undefined) {
          if (Array.isArray(param.value)) {
            // We iterate over the array and add each element as a separate parameter
            for (let value of param.value) {
              paramString += `${param.key}=${value}&`;
            }
          } else {
            paramString += `${param.key}=${param.value}&`;
          }
        }
      }
    }

    // If there are parameters, add them to the URL
    if (paramString) {
      // Remove the last "&" and add the parameters to the URL
      request.url = `${request.url}?${paramString.slice(0, -1)}`;
    }
    
    // Change the request type to GET
    request.type = 'GET';
    
    return request;
  };
/*
  // Métodos para manejar las operaciones de insertar, actualizar, eliminar (POST)
  this.insert = function(dm, data) {
    return {
      type: 'POST',
      url: dm.dataSource.insertUrl || dm.dataSource.url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(data),
    };
  };

  this.update = function(dm, keyField, data) {
    return {
      type: 'POST',
      url: dm.dataSource.updateUrl || dm.dataSource.url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(data),
    };
  };

  this.remove = function(dm, keyField, value) {
    return {
      type: 'POST',
      url: dm.dataSource.removeUrl || dm.dataSource.url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({ [keyField]: value }),
    };
  };*/
}

ScheduleCustomAdaptor.prototype = Object.create(UrlAdaptor.prototype);
ScheduleCustomAdaptor.prototype.constructor = ScheduleCustomAdaptor;

export default ScheduleCustomAdaptor;
